import React, { Component } from "react";
import { FontAwesomeIcon }            from '@fortawesome/react-fontawesome'
import { Button, FormControl, ListGroup, ListGroupItem, Modal } from "react-bootstrap";
import { invokeSetCreateReminder }    from "../../utils/AwsInvoke";
import { Colors }                     from "../../utils/Colors";
import KeywordsInput                  from "../../components/exercise/KeywordsInput";
import LoaderButton                   from "../../components/LoaderButton";
import YouTubeThumbnail               from "../../components/YouTubeThumbnail";
import uniqueId                       from 'lodash/uniqueId';
import "../../css/modal/ModalSearchKeywords.css";
import { invokeGetProgramSearchExercisesByKeyword } from "../../utils/AwsInvoke";

export default class ModalSearchKeywords extends Component {

    constructor(props) {
        super(props);

        this.state = {
            keywords_list: [],
            error: ""
        };
    }

    componentDidMount () {

    }

    getKeywords = async (keywords) => {

        if(keywords != "") {
            const results = await invokeGetProgramSearchExercisesByKeyword(keywords);

            var keywords_arr = [];
            for(var key in results) {
                var exercise_name = results[key].name;

                if(exercise_name != "" && exercise_name != null) {
                    var yt_id    = results[key].youtube_id;
                    var exerc_id = results[key].uid;

                    keywords_arr.push([yt_id, exerc_id, exercise_name]);
                }
            }

            this.setState({
                keywords: keywords, // actual keywords
                keywords_list: keywords_arr, // keywords list
                displayKeywordList: "inline"
            })
        } else {
            // Clear all states if the last "keyword" is deleted
            this.setState({
                keywords: keywords,
                keywords_list: []
            })
        }
    }

    selectKeywordExercise = (yt_id, exercise_id, exercise_name) => {
        console.log("exercise_id: " + exercise_id);
        console.log("exercise_name: " + exercise_name);

        this.props.setExerciseProps(exercise_id, exercise_name);
        this.props.onHide();
        /*this.setState({
            displayKeywordList: "none",
            keywordExerciseName: exercise_name,
            exercise_id: exercise_id,
            youtube_id: yt_id
        })*/
    }

    handleSubmit = async event => {

        this.setState({
            isLoading: true
        })

        //// Submit text msg /////
        /*if(message != "" && message != undefined) {
            console.log("Submit msg - trainer_phone: " + trainer_phone);

            const results = await invokeSendTrainerTextMessage(trainer_name, trainer_id, athlete_id, message, trainer_phone);
            var result = JSON.parse(results["body"]);

            if(result.status) {
                console.log("GO AND HIDE!");
                this.props.onHide("The text message was sent to " + this.props.athleteName + "."); // Close Modal //
            }

            this.setState({
                isLoading: false
            })
        } else {
            this.setState({
                error: "Looks like there's an error with your message. Try sending it again.",
                isLoading: false
            })
        }*/
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13) {
             this.props.onHide();
             this.handleSubmit();
        }
    }

    cancel () {
        this.props.onHide();
    }

    render() {
        var message = this.state.message;
        var error   = this.state.error;
        var keywordListItems = [];

        var key_list = this.state.keywords_list;
        for(var i=0; i < key_list.length; i++) {
            keywordListItems.push(<ListGroupItem key={uniqueId()}
                                                 className = "keywordListGroupItem"
                                                 onClick={this.selectKeywordExercise.bind(this, key_list[i][0], key_list[i][1], key_list[i][2])}
                                  >
                                        <YouTubeThumbnail yt_id={key_list[i][0]} width={60}/> &nbsp;
                                        <span className="keywordListGroupItem_ExerName">{(i+1)}. {key_list[i][2]}</span>
                                  </ListGroupItem>);
        }

        return (
            <Modal
                show    = {true /*this.state.showModalSearchKeywords*/ }
                onHide  = {this.props.onHide}
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26px">
                        <FontAwesomeIcon icon="search"
                                         className="modalBasicsTitleIcon"
                                         style={{ position:"relative", color: Colors.primary_color}}/>
                        <span className="modalBasicsTitle">
                             SEARCH BY KEYWORD
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <span className="modalBasicsBodySearchKeyword">
                          <div>
                              <div className="modalFormLabelBody">Keyword</div>
                                  <span>
                                      <KeywordsInput
                                          tags        = {this.state.keywords}
                                          style       = {{ border: "3px solid #ccc"}}
                                          getKeywords = {this.getKeywords}
                                      />
                                      <span className="modalSearchSubtitleLabel">
                                          (press return key after every word)
                                      </span>
                                      <span className="modalSimpleKeywordsListGroup"
                                            style={{display: this.state.displayKeywordList}}>
                                          <ListGroup style={{display: this.state.displayKeywordList}}
                                                     className = "keywordListGroup">
                                              { keywordListItems }
                                          </ListGroup>
                                      </span>
                                </span>
                          </div>
                          <span style={{paddingTop:15, fontSize: 16, color: "red"}}>{error}</span>
                    </span>
                    <br/>

                </Modal.Body>
                <Modal.Footer>
                    <span onClick = { () => this.cancel()} >
                        <LoaderButton
                          height    = {38}
                          width     = {150}
                          btncolor  = { Colors.cancel_button_bg }
                          type      = "button"
                          text      = "Cancel"
                          className="modalBasicsBtnClose"
                        />
                    </span>
                </Modal.Footer>

              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalSearchKeywords.js